import { StyledBKJAvatar } from 'modals/ShiftModal/src/views/DetailView/AvailableMembersTab/index.styled';
import React from 'react';
import { Jane } from 'types/graphql';
export function AvailabilityAvatar(props: Jane) {
  const { avatarUrls = { origin: '' }, pendingSignup } = props;
  return (
    <StyledBKJAvatar
      src={avatarUrls?.origin as unknown as string}
      width="30px"
      height="30px"
      fallbackAvatarColor="Grey4"
      showPendingSignUp={pendingSignup}
    />
  );
}
